import {requestHelpers} from '../../../../../helpers';
import {updateTodoList} from '../../../../../actions/todo_list/todo_list';

export const actions = {
    SET_ENDORSEMENTS: "SET_ENDORSEMENTS",
    REQUEST_ENDORSEMENTS_REQUEST: "REQUEST_ENDORSEMENTS_REQUEST",
    REQUEST_ENDORSEMENTS_SUCCESS: "REQUEST_ENDORSEMENTS_SUCCESS",
    REQUEST_ENDORSEMENTS_ERROR: "REQUEST_ENDORSEMENTS_ERROR",
    PUBLISH_ENDORSEMENTS_REQUEST: "PUBLISH_ENDORSEMENTS_REQUEST",
    PUBLISH_ENDORSEMENTS_SUCCESS: "PUBLISH_ENDORSEMENTS_SUCCESS",
    PUBLISH_ENDORSEMENTS_ERROR: "PUBLISH_ENDORSEMENTS_ERROR",
    UNPUBLISH_ENDORSEMENTS_SUCCESS: "UNPUBLISH_ENDORSEMENTS_SUCCESS",
    DELETE_ENDORSEMENT_SUCCESS: "DELETE_ENDORSEMENT_SUCCESS",
};

export const setEndorsements = ( profile ) => {
    const pendingEndorsements =  profile.endorsements.filter( endorsement => endorsement.is_approved === 0 )
        .map( endorsement => endorsement.detail = { body: endorsement, personId: profile.id } ),
        receivedEndorsements = profile.endorsements.filter( endorsement => ( endorsement.is_visible === 0 && endorsement.is_approved === 1) )
            .map( endorsement => endorsement.detail = { body: endorsement, personId: profile.id } ),
        publishedEndorsements = profile.endorsements.filter( endorsement => endorsement.is_visible === 1 )
        .map( endorsement => endorsement.detail = { body: endorsement, personId: profile.id } );

        const noData = publishedEndorsements.length === 0;
	    return {
		    type: actions.SET_ENDORSEMENTS,
            personId: profile.id,
		    pending: pendingEndorsements.length === 0 ? [] : pendingEndorsements,
		    received: receivedEndorsements.length === 0 ? [] : receivedEndorsements,
		    published: publishedEndorsements.length === 0 ? [] : publishedEndorsements,
            noData,
	    }
};

export const requestEndorsement = ( personId, payload, type = null, callbackToHOC) => {
    return (dispatch) => {
        dispatch({
            type: actions.REQUEST_ENDORSEMENTS_REQUEST,
            isEndorsementsFetching: true,
            isEndorsementsError: false,
        });

        requestHelpers
            .authenticatedPostRequest(`/profiles/${personId}/endorsement/request`, payload, "POST")
            .then((response) => {
                callbackToHOC();
                payload.id = response.data;
                return dispatch({
                    type: actions.REQUEST_ENDORSEMENTS_SUCCESS,
                    personId,
                    body: payload,
                    isEndorsementsFetching: false,
                    isEndorsementsError: false,
                })
            })
            .catch((error) => {
                callbackToHOC(error);
            });
      dispatch(updateTodoList(personId, 8));
    }
};


export const endorsementsApiCall = ( personId, payload, type, callbackToHOC ) => {
    const endpoint = ( payload.type === 'UPDATE' && ( payload.is_visible ? `/invisible` : `/visible` ) ) || null;
    const actionToDispatch = payload.type === 'UPDATE'
                                ? ( payload.is_visible ? "UNPUBLISH_ENDORSEMENTS_SUCCESS" : "PUBLISH_ENDORSEMENTS_SUCCESS")
                                : "DELETE_ENDORSEMENT_SUCCESS";
    return (dispatch) => {
        dispatch({
            type: actions.PUBLISH_ENDORSEMENTS_REQUEST,
            isEndorsementsFetching: true,
            isEndorsementsError: false,
        });
        requestHelpers
            .authenticatedPostRequest(`/profiles/${personId}/endorsement/${ payload.id }${ endpoint }`, payload, type === 'UPDATE' ? 'PUT' : 'DELETE')
            .then((response) => {
                // doesn't need callback to HOC cause the form is supposed to stay open
                return dispatch({
                    type: actions[actionToDispatch],
                    body: payload,
                    isEndorsementsFetching: false,
                    isEndorsementsError: false,
                })
            })
            .catch((error) => {
                callbackToHOC(error);
            })
      dispatch(updateTodoList(personId, 8))
    }
};


// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/endorsements.js